// extracted by mini-css-extract-plugin
export var adjacentSlide = "_ok-9";
export var arrowButtonContainer = "_ok-5";
export var arrowButtonIcon = "_ok-6";
export var carouselArrowButton = "_ok-2";
export var carouselElementContainer = "_ok-1";
export var currentSlide = "_ok-8";
export var left = "_ok-3";
export var otherSlide = "_ok-a";
export var productCarouselContainer = "_ok-0";
export var right = "_ok-4";
export var sliderOverflow = "_ok-7";